import { createContext } from 'react';
import CmsService from '../Services/CmsService';

const CmsContext = createContext<CmsService>(new CmsService());

export default CmsContext;
